// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__X60dq","range":"MonthRangeSwitch_range__cBc4e","disabled":"MonthRangeSwitch_disabled__2j3yu"};